export const REQUEST_TRACE_ID_HEADER = 'x-request-trace-id';

export const REQUEST_TRACE_TIME_STRING_HEADER = 'x-request-trace-time-string';

export const REQUEST_TRACE_TIME_STAMP_HEADER = 'x-request-trace-time-stamp';
